// composables/useBootstrapLoaded.ts
import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useBootstrapLoaded() {
  const isBootstrapLoaded = ref(false)
  let interval = 0

  onMounted(() => {
    interval = window.setInterval(() => {
      if (typeof window.bootstrap !== 'undefined') {
        isBootstrapLoaded.value = true
        clearInterval(interval)
      }
    }, 300)
  })

  onBeforeUnmount(() => {
    clearInterval(interval)
  })

  return { isBootstrapLoaded }
}
